// Import Firebase SDK
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// 🔹 Configurația aplicației tale (din Firebase Console)
const firebaseConfig = {
  projectId: "traseuaplicativ-9376e",
  appId: "1:207474993774:web:b99d8a33234cb782a0947f",
  storageBucket: "traseuaplicativ-9376e.firebasestorage.app",
  apiKey: "AIzaSyC-odvWh77MVxiaj_RY9VB9Gj8kFGzEvXE",
  authDomain: "traseuaplicativ-9376e.firebaseapp.com",
  messagingSenderId: "207474993774",
  measurementId: "G-C8TR5RRTYX",
  projectNumber: "207474993774",
  version: "2",
};
// 🔹 Inițializăm aplicația Firebase
const app = initializeApp(firebaseConfig);

// 🔹 Exportăm instanțele pentru a le folosi oriunde în aplicație
export const db = getFirestore(app); // pentru Firestore
export const storage = getStorage(app); // pentru Firebase Storage
export const auth = getAuth(app);
export default app;
